import { WindowWithScript } from "./models/window";
import { onDOMContentLoaded } from "@fidget/common/utils/onDOMContentLoaded";
import { MainModule } from "./main.module";

const mainModule = new MainModule(window as WindowWithScript);

onDOMContentLoaded(() => mainModule.bootstrap());
